function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { createContext, useContext, useEffect, useMemo } from 'react';
import cn from 'classnames';
import { colord } from 'colord';
import { useStateInRef } from "../../utils/useStateInRef";
import styles from "./Theme.module.scss";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
function getFullTheme(theme) {
  const fullTheme = _objectSpread({}, theme);
  const textStandard = theme['--text-standard'];
  if (textStandard) {
    fullTheme['--text-standard-light'] = colord(textStandard).lighten(0.1).toHex();
  }
  const buttonPrimary = theme['--button-primary'];
  if (buttonPrimary) {
    fullTheme['--button-primary-dark'] = colord(buttonPrimary).darken(0.1).toHex();
    fullTheme['--button-primary-light'] = colord(buttonPrimary).lighten(0.1).toHex();
  }
  const buttonDisabled = theme['--button-disabled'];
  if (buttonDisabled) {
    fullTheme['--button-disabled-dark'] = colord(buttonDisabled).darken(0.1).toHex();
  }
  return fullTheme;
}
const ThemeContext = /*#__PURE__*/createContext({});
export const useTheme = () => useContext(ThemeContext);
export function ScopedThemeProvider(props) {
  const {
    theme,
    children,
    className,
    maxHeight,
    maxWidth,
    testId,
    style
  } = props;
  const fullTheme = useMemo(() => getFullTheme(theme), [theme]);
  return /*#__PURE__*/_jsx(ThemeContext.Provider, {
    value: fullTheme,
    children: /*#__PURE__*/_jsx("div", {
      className: cn(className, {
        [styles.maxHeight]: maxHeight,
        [styles.maxWidth]: maxWidth
      }),
      style: _objectSpread(_objectSpread({}, style), fullTheme),
      "data-testid": testId,
      children: children
    })
  });
}
export function RootThemeProvider(props) {
  const {
    theme,
    children
  } = props;
  const getTheme = useStateInRef(theme);
  useEffect(() => {
    const root = document.documentElement;
    Object.entries(getFullTheme(getTheme())).forEach(_ref => {
      let [key, value] = _ref;
      root.style.setProperty(key, value);
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}